import actionTypes from '../constants/action-types';

const getDomains = (options = {}) => ({
  type: actionTypes.GET_DOMAINS,
  payload: {
    options,
  },
});

export default getDomains;
